<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="OMS传单/确认监测"></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_4" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_4",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_4"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          top: "12%",
          bottom: "16%",
          containLabel: true,
        },
        legend: {
          data: ["传单", "打款确认"],
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: [
              "商家1",
              "商家2",
              "商家3",
              "商家4",
              "商家5",
              "商家6",
              "商家7",
              "商家8",
              "商家9",
              "商家10",
            ],
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "传单",
            type: "bar",
            data: [4.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 23.2, 25.6, 76.7],
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(21,157,255,0.1)" },
                { offset: 1, color: "rgba(21,157,255,1)" },
              ]),
            },
          },
          {
            name: "打款确认",
            type: "bar",
            data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 2.6, 5.9, 9.0],
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(34,228,255,0.1)" },
                { offset: 1, color: "rgba(34,228,255,1)" },
              ]),
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #left_4 {
    height: 100%;
  }
}
</style>